module.exports = __webpack_public_path__ + "static/media/icon-stores.a7f16b63.svg";